import { render, staticRenderFns } from "./IbanField.vue?vue&type=template&id=2b0736da&"
import script from "./IbanField.vue?vue&type=script&lang=ts&"
export * from "./IbanField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports